module.exports = __webpack_public_path__ + "img/db.471b1112.svg";